import { ref } from 'vue';

// Histórico volátil das mensagens de toast (getMsgInformacao/Atencao/Erro/Sucesso).
// Fica só em memória: some ao recarregar a página ou ao sair do sistema.
const LIMITE = 200;

const mensagens = ref([]);
const naoLidas = ref(0);
let sequencia = 0;

function textoDaMensagem(vMsg) {
    if (vMsg === null || vMsg === undefined) return '';
    if (typeof vMsg === 'string') return vMsg;
    if (vMsg instanceof Error) return vMsg.message;
    try {
        return JSON.stringify(vMsg);
    } catch {
        return String(vMsg);
    }
}

export function useHistoricoMensagens() {
    function registrar(tipo, vMsg, tela) {
        mensagens.value.unshift({
            id: ++sequencia,
            data: new Date(),
            tipo,
            mensagem: textoDaMensagem(vMsg),
            tela: tela || ''
        });
        if (mensagens.value.length > LIMITE) mensagens.value.length = LIMITE;
        naoLidas.value++;
    }

    function marcarComoLidas() {
        naoLidas.value = 0;
    }

    function limpar() {
        mensagens.value = [];
        naoLidas.value = 0;
    }

    return { mensagens, naoLidas, registrar, marcarComoLidas, limpar };
}
